import gql from "graphql-tag";

export const PROCESS_UPDATE = gql`
    subscription processUpdate($params: ProcessRequestParams!) {
        processStatusUpdate(params: $params) {
            requestSysId
            processState
            companySysId
            processAutomationStates
        }
    }
`;
